import { useHentAlleEfteruddannelsesperiodeIndberetninger } from "@/hooks/useHentEfteruddannelsesperiode";
import RoundedCard from "../../components/RoundedCard";
import ViewLayout from "../../components/ViewLayout";
import ReportingPeriodsTable from "../../components/reporting-periods/ReportingPeriodsTable";
import IndberetningerInfoContent from "./components/IndberetningerInfoContent";

const IndberetningerView = () => {
  const {
    data: indberetninger = [],
    isError,
    isLoading,
  } = useHentAlleEfteruddannelsesperiodeIndberetninger();

  return (
    <ViewLayout
      title="Indberetninger"
      description="Her kan du se dine efteruddannelsesperioder, status for indberetning og relevante frister."
      infoTitle="Sådan læser du dine indberetninger"
      infoDescription="Frister, status og overførte lektioner"
      infoText={<IndberetningerInfoContent />}
    >
      <RoundedCard
        className="mt-4"
        bodyClassName="p-0 mt-3"
        header="Mine indberetninger"
        description="Oversigt over dine efteruddannelsesperioder og indberetningsstatus."
      >
        <ReportingPeriodsTable
          isError={isError}
          isLoading={isLoading}
          reportPeriods={indberetninger}
        />
      </RoundedCard>
    </ViewLayout>
  );
};

export default IndberetningerView;
